import { Routes } from '@angular/router';
import { PageName } from '~backoffice/app/~shared/models/shared.models';
import { LayoutComponent } from './~shared/layouts/layout/layout.component';
import { NotFoundComponent } from './not-found/not-found.component';
import { AUTHENTICATED_GUARD } from './~shared/guards/authenticated.guard';

export const routes: Routes = [
  {
    path: 'auth',
    children: [
      {
        path: 'signin',
        loadComponent: () =>
          import('./auth/pages/signin/signin.component').then(
            m => m.SigninComponent
          ),
        data: {
          pageName: PageName.signin,
          title: 'Inscription'
        }
      },
      {
        path: 'password/resetting/request',
        loadComponent: () =>
          import('./auth/pages/password-reset/password-reset.component').then(
            m => m.PasswordResetComponent
          ),
        data: {
          pageName: PageName.passwordReset
        }
      },
      {
        path: 'password/change',
        loadComponent: () =>
          import('./auth/pages/password-init/password-init.component').then(
            m => m.PasswordInitComponent
          ),
        data: {
          layoutHidden: true,
          pageName: PageName.passwordInit
        }
      }
    ]
  },
  {
    path: '',
    component: LayoutComponent,
    canActivate: [AUTHENTICATED_GUARD],
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./home/pages/home/home.component').then(m => m.HomeComponent),
        data: {
          pageName: PageName.home,
          headerTitle: 'Tableau de bord'
        }
      },
      {
        path: 'channel-and-radio/channel-tv',
        loadComponent: () =>
          import(
            './channel-and-radio/pages/channel-tv/channel-tv.component'
          ).then(m => m.ChannelTVComponent),
        data: {
          pageName: PageName.channelTV,
          headerTitle: 'Chaines TV & Radios'
        }
      },
      {
        path: 'channel-and-radio/channel-webtv',
        loadComponent: () =>
          import(
            './channel-and-radio/pages/channel-webtv/channel-webtv.component'
          ).then(m => m.ChannelWebtvComponent),
        data: {
          pageName: PageName.channelWebtv,
          headerTitle: 'Chaines TV & Radios'
        }
      },
      {
        path: 'channel-and-radio/channel-radio',
        loadComponent: () =>
          import(
            './channel-and-radio/pages/channel-radio/channel-radio.component'
          ).then(m => m.ChannelRadioComponent),
        data: {
          pageName: PageName.channelRadio,
          headerTitle: 'Chaines TV & Radios'
        }
      },
      {
        path: 'channel-and-radio/create-channel',
        loadComponent: () =>
          import(
            './channel-and-radio/pages/create-channel-and-radio/create-channel-and-radio.component'
          ).then(m => m.CreateChannelAndRadioComponent),
        data: {
          pageName: PageName.createChannel,
          headerTitle: 'Ajouter une nouvelle chaîne'
        }
      },
      {
        path: 'channel-and-radio/live-stream/:channelId',
        loadComponent: () =>
          import('./live-stream/pages/live-stream/live-stream.component').then(
            m => m.LiveStreamComponent
          ),
        data: {
          pageName: PageName.liveStream,
          headerTitle: 'Live Streams'
        }
      },
      {
        path: 'channel-and-radio/:channelId',
        loadComponent: () =>
          import(
            './channel-and-radio/pages/create-channel-and-radio/create-channel-and-radio.component'
          ).then(m => m.CreateChannelAndRadioComponent),
        data: {
          pageName: PageName.createChannel,
          headerTitle: 'Modifier la chaîne'
        }
      },
      {
        path: 'content/library',
        loadComponent: () =>
          import('./video/pages/video-library/video-library.component').then(
            m => m.VideoLibraryComponent
          ),
        data: {
          pageName: PageName.content,
          headerTitle: 'Publication des vidéos'
        }
      },
      {
        path: 'content/kaltura/library',
        loadComponent: () =>
          import(
            './video/pages/kaltura-library/kaltura-library.component'
          ).then(m => m.KalturaLibraryComponent),
        data: {
          pageName: PageName.kaltura,
          headerTitle: 'Publication des vidéos'
        }
      },
      {
        path: 'programs',
        loadComponent: () =>
          import('./program/pages/programs/programs.component').then(
            m => m.ProgramsComponent
          ),
        data: {
          pageName: PageName.program,
          headerTitle: 'Programmes'
        }
      },
      {
        path: 'genres',
        loadComponent: () =>
          import('./genre/pages/genre/genre.component').then(
            m => m.GenreComponent
          ),
        data: {
          pageName: PageName.genres,
          headerTitle: 'Genres'
        }
      },
      {
        path: 'personnes',
        loadComponent: () =>
          import('./person//pages/person/person.component').then(
            m => m.PersonComponent
          ),
        data: {
          pageName: PageName.person,
          headerTitle: 'Personnes'
        }
      },
      {
        path: 'themes',
        loadComponent: () =>
          import('./thematic/pages/thematic/thematic.component').then(
            m => m.ThematicComponent
          ),
        data: {
          pageName: PageName.thematic,
          headerTitle: 'Thématiques'
        }
      },
      {
        path: 'badges',
        loadComponent: () =>
          import('./badges/pages/badges/badges.component').then(
            m => m.BadgesComponent
          ),
        data: {
          pageName: PageName.badges,
          headerTitle: 'Badges'
        }
      },
      {
        path: 'tags',
        loadComponent: () =>
          import('./tags/pages/tags/tags.component').then(m => m.TagsComponent),
        data: {
          pageName: PageName.tags,
          headerTitle: 'Tags'
        }
      },
      {
        path: 'users',
        loadComponent: () =>
          import('./users/pages/users/users.component').then(
            m => m.UsersComponent
          ),
        data: {
          pageName: PageName.users,
          headerTitle: 'Utilisateurs'
        }
      },
      {
        path: 'notifications',
        loadComponent: () =>
          import(
            './notifications/pages/notifications/notifications.component'
          ).then(m => m.NotificationsComponent),
        data: {
          pageName: PageName.notifications,
          headerTitle: 'Notifications Push'
        },
        canActivate: [AUTHENTICATED_GUARD]
      },
      {
        path: 'constructors',
        loadComponent: () =>
          import(
            './constructors/pages/page-constructor-library/page-constructor-library.component'
          ).then(m => m.PageConstructorLibraryComponent),
        data: {
          pageName: PageName.constructors,
          headerTitle: 'Constructeurs de page'
        }
      },
      {
        path: 'constructors/home',
        loadComponent: () =>
          import(
            './constructors/pages/page-constructor/page-constructor.component'
          ).then(m => m.PageConstructorComponent),
        data: {
          pageName: PageName.homeConstructor
        }
      },
      {
        path: 'constructors/channel',
        loadComponent: () =>
          import(
            './constructors/pages/page-constructor/page-constructor.component'
          ).then(m => m.PageConstructorComponent),
        data: {
          pageName: PageName.channelConstructor
        }
      },
      {
        path: 'constructors/program',
        loadComponent: () =>
          import(
            './constructors/pages/page-constructor/page-constructor.component'
          ).then(m => m.PageConstructorComponent),
        data: {
          pageName: PageName.programConstructor
        }
      },
      {
        path: 'constructors/presentation',
        loadComponent: () =>
          import(
            './constructors/pages/presentation-constructor/presentation-constructor.component'
          ).then(m => m.PresentationConstructorComponent),
        data: {
          pageName: PageName.presentationConstructor
        }
      },
      {
        path: 'comments',
        children: [
          {
            path: '',
            loadComponent: () =>
              import('./comments/pages/comments/comments.component').then(
                m => m.CommentsComponent
              ),
            data: {
              pageName: PageName.comments,
              headerTitle: 'Commentaires'
            }
          },
          {
            path: 'censored-words',
            loadComponent: () =>
              import(
                './blacklisted/pages/blacklisted/blacklisted.component'
              ).then(m => m.BlacklistedComponent),
            data: {
              pageName: PageName.blacklisted,
              headerTitle: 'Mot censurés'
            }
          }
        ]
      },
      {
        path: 'forms/join-us',
        loadComponent: () =>
          import('./requests/pages/join-us/join-us.component').then(
            m => m.JoinUsComponent
          ),
        data: {
          pageName: PageName.joinUs,
          headerTitle: 'Formulaires'
        }
      },
      {
        path: 'forms/contact-us',
        loadComponent: () =>
          import('./requests/pages/contact-us/contact-us.component').then(
            m => m.ContactUsComponent
          ),
        data: {
          pageName: PageName.contactUs,
          headerTitle: 'Formulaires'
        }
      },
      {
        path: 'forms/newsletter',
        loadComponent: () =>
          import('./requests/pages/newsletter/newsletter.component').then(
            m => m.NewsletterComponent
          ),
        data: {
          pageName: PageName.newsletter,
          headerTitle: 'Formulaires'
        }
      },
      {
        path: 'settings/security',
        loadComponent: () =>
          import('./settings/pages/settings/settings.component').then(
            m => m.SettingsComponent
          ),
        data: {
          pageName: PageName.settings,
          headerTitle: 'Paramètres',
          headerSubtitle: 'Sécurité'
        }
      },
      {
        path: 'settings/notifications',
        loadComponent: () =>
          import('./settings/pages/notifications/notifications.component').then(
            m => m.NotificationsComponent
          ),
        data: {
          pageName: PageName.settings,
          headerTitle: 'Paramètres',
          headerSubtitle: 'Notifications'
        }
      },
      {
        path: 'settings/administrators',
        loadComponent: () =>
          import(
            './settings/pages/administrators/administrators.component'
          ).then(m => m.AdministratorsComponent),
        data: {
          pageName: PageName.administrators,
          headerTitle: 'Paramètres',
          headerSubtitle: 'Administrateurs et rôles'
        }
      },
      {
        path: 'settings/groups',
        loadComponent: () =>
          import('./settings/pages/groups/groups.component').then(
            m => m.GroupsComponent
          ),
        data: {
          pageName: PageName.groups,
          headerTitle: 'Paramètres',
          headerSubtitle: 'Groupes'
        }
      },
      {
        path: 'settings/accessibility',
        children: [
          {
            path: 'application',
            loadComponent: () =>
              import(
                './settings/pages/accessibility/application/application.component'
              ).then(m => m.ApplicationComponent),
            data: {
              pageName: PageName.application,
              headerTitle: 'Accessibilité',
              headerSubtitle: 'Accessibilité'
            },
            canActivate: [AUTHENTICATED_GUARD]
          },
          {
            path: 'geoblocking',
            loadComponent: () =>
              import(
                './settings/pages/accessibility/geoblocking/geoblocking.component'
              ).then(m => m.GeoblockingComponent),
            data: {
              pageName: PageName.geoblocking,
              headerTitle: 'Accessibilité',
              headerSubtitle: 'Accessibilité'
            },
            canActivate: [AUTHENTICATED_GUARD]
          },
          {
            path: 'view-statistics',
            loadComponent: () =>
              import(
                './settings/pages/accessibility/view-statistics/view-statistics.component'
              ).then(m => m.ViewStatisticsComponent),
            data: {
              pageName: PageName.viewStatistics,
              headerTitle: 'Accessibilité',
              headerSubtitle: 'Accessibilité'
            },
            canActivate: [AUTHENTICATED_GUARD]
          },
          {
            path: '',
            redirectTo: 'application',
            pathMatch: 'prefix'
          }
        ]
      },
      {
        path: 'profile',
        loadComponent: () =>
          import('./profile/pages/profile/profile.component').then(
            m => m.ProfileComponent
          ),
        data: {
          pageName: PageName.profile,
          headerTitle: 'Mon profil'
        }
      },
      {
        path: '**',
        component: NotFoundComponent
      }
    ]
  },
  {
    path: '**',
    component: NotFoundComponent
  }
];
